<a class="skip-link" href="#main-content" (click)="skipToMainContent($event)">
  Saltar al contenido
</a>
<mat-toolbar class="app-header">
  @if (
    authenticationState() === 'authenticated' && platformContext.applicationState() === 'ready'
  ) {
    <button
      #navigationToggle
      mat-icon-button
      type="button"
      class="navigation-trigger"
      aria-label="Abrir navegación principal"
      aria-controls="primary-navigation-drawer"
      [attr.aria-expanded]="navigationOpened()"
      (click)="toggleNavigation()"
    >
      <span class="navigation-trigger-symbol" aria-hidden="true">☰</span>
    </button>
  }

  <a class="platform-brand" routerLink="/" aria-label="PreNómina, ir al inicio">
    <img
      class="platform-brand-logo"
      src="/branding/prenomina-logo.png"
      width="166"
      height="199"
      alt=""
    />
    <span>PreNómina</span>
  </a>

  @if (
    authenticationState() === 'authenticated' && platformContext.applicationState() === 'ready'
  ) {
    <div class="active-context" aria-label="Contexto de trabajo actual">
      @if (companyLogo(); as logo) {
        <img
          class="company-logo"
          [src]="logo.url"
          [alt]="logo.alt"
          (error)="companyLogoLoadFailed(logo.url)"
        />
      }
      <span class="context-copy">
        @if (
          platformContext.availableCompanies().length > 1 &&
          platformContext.selectedCompany() !== null
        ) {
          <button
            type="button"
            class="context-item context-selector company-context-item company-context-action"
            aria-label="Cambiar empresa"
            (click)="changeCompany()"
          >
            <span class="context-label">Empresa</span>
            <span class="context-value context-action-value">
              <span class="company-name">{{ platformContext.selectedCompany()!.name }}</span>
              <span class="context-chevron" aria-hidden="true">⌄</span>
            </span>
          </button>
        } @else {
          <span class="context-item company-context-item">
            <span class="context-label">Empresa</span>
            <span class="context-value company-name">
              {{ platformContext.selectedCompany()?.name ?? 'Sin selección' }}
            </span>
          </span>
        }

        <span class="context-separator" aria-hidden="true">·</span>

        @if (
          (platformContext.selectedCompany()?.allowedBranches?.length ?? 0) > 1 &&
          platformContext.selectedBranch() !== null
        ) {
          <button
            type="button"
            class="context-item context-selector branch-context-item branch-context-action"
            aria-label="Cambiar sucursal"
            (click)="changeBranch()"
          >
            <span class="context-label">Sucursal</span>
            <span class="context-value context-action-value branch-context-value">
              @if (platformContext.selectedBranch(); as branch) {
                <span
                  class="branch-display"
                  [attr.aria-label]="branch.code + ' — ' + branch.name"
                  [attr.title]="branch.code + ' — ' + branch.name"
                >
                  <span class="branch-code">{{ branch.code }}</span>
                  <span class="branch-name" aria-hidden="true"> — {{ branch.name }}</span>
                </span>
                <span class="context-chevron" aria-hidden="true">⌄</span>
              }
            </span>
          </button>
        } @else {
          <span class="context-item branch-context-item">
            <span class="context-label">Sucursal</span>
            <span class="context-value branch-context-value">
              @if (platformContext.selectedBranch(); as branch) {
                <span
                  class="branch-display"
                  [attr.aria-label]="branch.code + ' — ' + branch.name"
                  [attr.title]="branch.code + ' — ' + branch.name"
                >
                  <span class="branch-code">{{ branch.code }}</span>
                  <span class="branch-name" aria-hidden="true"> — {{ branch.name }}</span>
                </span>
              } @else {
                Sin selección
              }
            </span>
          </span>
        }
      </span>
    </div>

    @if (
      platformContext.availableTenants().length > 1 && platformContext.selectedTenant() !== null
    ) {
      <button mat-button type="button" class="change-tenant-action" (click)="changeTenant()">
        <span class="tenant-action-wide">Cambiar organización</span>
        <span class="tenant-action-compact" aria-hidden="true">Organización⌄</span>
      </button>
    }
  }

  <span class="spacer"></span>
  <span class="environment-label">{{ environmentName }}</span>

  @if (authenticationState() === 'authenticated') {
    <button
      mat-button
      type="button"
      class="desktop-user-menu-trigger"
      aria-label="Opciones de usuario"
      [matMenuTriggerFor]="userMenu"
    >
      <span class="user-name">{{ platformContext.platformUser()?.name || 'Usuario' }}</span>
      <span class="user-menu-chevron" aria-hidden="true">⌄</span>
    </button>
    <button
      mat-icon-button
      type="button"
      class="compact-user-menu-trigger"
      aria-label="Opciones de usuario"
      [matMenuTriggerFor]="userMenu"
    >
      <span class="compact-menu-symbol" aria-hidden="true">⋮</span>
    </button>
    <mat-menu #userMenu="matMenu">
      @if (platformContext.applicationState() === 'ready') {
        <button
          mat-menu-item
          type="button"
          class="user-menu-change-password"
          (click)="openChangePassword()"
        >
          Cambiar contraseña
        </button>
      }
      <button
        mat-menu-item
        type="button"
        class="user-menu-logout"
        [disabled]="signingOut()"
        (click)="signOut()"
      >
        {{ signingOut() ? 'Saliendo…' : 'Cerrar sesión' }}
      </button>
    </mat-menu>
  }
</mat-toolbar>
@if (authenticationState() === 'authenticated') {
  <mat-drawer-container
    class="navigation-container"
    backdropClass="app-navigation-backdrop"
    [hasBackdrop]="temporaryNavigation()"
    [autosize]="!temporaryNavigation()"
  >
    <mat-drawer
      id="primary-navigation-drawer"
      class="primary-navigation-drawer"
      [class.navigation-collapsed]="
        platformContext.applicationState() === 'ready' &&
        !temporaryNavigation() &&
        navigationCollapsed()
      "
      position="start"
      [mode]="temporaryNavigation() ? 'over' : 'side'"
      [opened]="platformContext.applicationState() === 'ready' && navigationOpened()"
      [autoFocus]="temporaryNavigation()"
      (openedChange)="navigationOpenedChanged($event)"
      (closedStart)="restoreNavigationFocus()"
    >
      @if (platformContext.applicationState() === 'ready') {
        <app-navigation
          [items]="primaryNavigation"
          [temporary]="temporaryNavigation()"
          [collapsed]="navigationCollapsed()"
          (collapsedChange)="navigationCollapsed.set($event)"
          (itemSelected)="navigationItemSelected()"
        />
      }
    </mat-drawer>

    <mat-drawer-content class="navigation-content">
      @if (
        platformContext.applicationState() === 'preparing' ||
        (platformContext.applicationState() === 'needsIntervention' && !isContextSelectionRoute())
      ) {
        <main class="app-content bootstrap-state">
          <app-loading-state mode="section" label="Preparando tu espacio de trabajo…" />
          <p class="bootstrap-state-detail">
            @if (platformContext.applicationState() === 'needsIntervention') {
              Estamos preparando la selección de tu contexto.
            } @else {
              Estamos cargando tu contexto y permisos.
            }
          </p>
        </main>
      } @else if (platformContext.applicationState() === 'error') {
        <main class="app-content bootstrap-state">
          <app-blocking-error-state
            title="No pudimos preparar tu espacio de trabajo"
            message="No fue posible completar una carga necesaria. Puedes intentarlo nuevamente."
            [primaryActionLabel]="retryingPreparation() ? 'Reintentando…' : 'Reintentar'"
            [primaryActionDisabled]="retryingPreparation()"
            (primaryAction)="retryApplicationPreparation()"
          />
        </main>
      }

      <main
        #mainContent
        id="main-content"
        tabindex="-1"
        aria-label="Contenido principal"
        class="app-content bootstrap-route-host main-content-focus-target"
        [class.app-content-fluid]="fluidCapture()"
        [class.bootstrap-route-host-hidden]="!isRouteContentVisible()"
        [attr.aria-hidden]="isRouteContentVisible() ? null : 'true'"
        [attr.inert]="isRouteContentVisible() ? null : ''"
      >
        <router-outlet />
      </main>
    </mat-drawer-content>
  </mat-drawer-container>
} @else {
  <main
    #mainContent
    id="main-content"
    tabindex="-1"
    aria-label="Contenido principal"
    class="app-content app-content-without-navigation main-content-focus-target"
  >
    <router-outlet />
  </main>
}
